module.exports = __webpack_public_path__ + "static/media/feature-cost.ce559208.svg";